import { useTheme } from '@material-ui/core'
import React from 'react'
import { AvatarCircle, Container } from '../..'

// models
import { Option } from './ContextMenu'
import { typographyStyle } from '../../../theme/typographyStyle'

// components

interface Props {
    option: Option
}

const MentionOption = (props: Props) => {
    const { option } = props

    const theme = useTheme()

    return (
        <Container alignItems="center">
            <AvatarCircle
                text={option.name}
                initials
                styles={{ container: { margin: theme.spacing(0.375) } }}
            />
            <span
                style={{
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(0.125),
                    ...typographyStyle(theme.typography.body2),
                    fontWeight: 700,
                }}
            >
                {option.name}
            </span>
        </Container>
    )
}

export default MentionOption
